import {IEnvironmentGlobals} from "./IEnvironmentGlobals";

export class EnvGlobalsHandler {
    private static _envGlobals: IEnvironmentGlobals;

    /** instance of concrete environment globals. */
    public static get globals(): IEnvironmentGlobals {
        if (EnvGlobalsHandler._envGlobals == null) {
            // The global variables must be initialized by game before any request
            throw new Error("The environment globals are not initialized by game.");
        }
        return EnvGlobalsHandler._envGlobals;
    }

    /**
     * @private
     */
    public static setEnvGlobalsClass(instance: IEnvironmentGlobals): void {
        EnvGlobalsHandler._envGlobals = instance;
    }

}
